import { Icon } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

import { MinusIcon } from '..';
import { PlusIcon } from '../assets/icons';
import { CircleIconButton } from './CircleIconButton';
import { GridRowCell } from './Grid';
import { RowSimple } from './RowSimple';
import { RowSimpleProps } from './RowSimple';

type RowSelectableProps = { selected?: boolean } & Omit<RowSimpleProps, 'ref'>;

export const RowSelectable = ({ children, sx, selected, ...props }: RowSelectableProps) => {
  return (
    <RowSimple
      noBorderRadius
      sx={(theme) => ({
        cursor: 'pointer',
        ':hover': {
          '& .MuiIconButton-root': {
            background: theme.palette.primary.main,
            '.MuiIcon-root': {
              color: theme.palette.background.paper,
            },
          },
        },
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
      {...props}
    >
      {children}
      <GridRowCell>
        <CircleIconButton>
          {selected ? (
            <Icon
              sx={(theme) => ({
                color: theme.palette.common.main4,
                fontSize: theme.spacing(1.5),
              })}
            >
              <MinusIcon />
            </Icon>
          ) : (
            <Icon fontSize="small" sx={(theme) => ({ color: theme.palette.common.main4 })}>
              <PlusIcon />
            </Icon>
          )}
        </CircleIconButton>
      </GridRowCell>
    </RowSimple>
  );
};
